import React from 'react';

import { get } from '@lumapps/constants';
import { useInstanceLogo } from '@lumapps/instance/hooks/useInstanceLogo';
import { useSelector } from '@lumapps/redux/react';
import { useQueryParams } from '@lumapps/router';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';
import { usePageTitle } from '@lumapps/utils/hooks/usePageTitle';

import { LoginPage } from './LoginPage';
import { LoginPageProps } from './LoginPageProps';

const ConnectedLoginPage: React.FC<Omit<LoginPageProps, 'logo'>> = (props) => {
    const { title } = props;
    const logo = useInstanceLogo();
    usePageTitle(title);
    const { correlationId } = useQueryParams();
    const Config = get();
    const currentLanguage = useSelector(currentLanguageSelector);

    return (
        <LoginPage
            {...props}
            logo={logo}
            correlationId={correlationId}
            loginGuidelines={Config.loginGuidelines}
            currentLanguage={currentLanguage}
        />
    );
};

export { ConnectedLoginPage as LoginPage };
